import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaHome, FaChevronRight, FaMapMarkerAlt, FaPhoneAlt,
  FaSearch, FaDirections, FaPhone,
  FaBuilding, FaCity, FaTimes, FaStar,
} from 'react-icons/fa';
import { GiBank } from 'react-icons/gi';
import { database, ref as dbRef, get } from '../../firebase';
import { useLanguage } from '../../contexts/LanguageContext';
import { useEffect } from 'react';

const Branch = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [selectedCity, setSelectedCity] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBranch, setSelectedBranch] = useState(null);

  // Use language from context directly
  const currentLang = language;

  // Translations for branch page content
  const translations = {
    en: {
      pageTitle: 'Our Branches',
      pageSubtitle: 'Find your nearest Shivpratap Multistate Bank branch',
      contactButton: 'Contact Us',
      breadcrumbHome: 'Home',
      breadcrumbBranches: 'Branches',
      headOffice: 'Head Office',
      totalBranches: 'Total Branches',
      cities: 'Cities',
      searchPlaceholder: 'Search branch by name, city, address, or phone number...',
      grid: 'Grid',
      list: 'List',
      allBranches: 'All Branches',
      headOfficeBtn: 'Head Office',
      vitaBranches: 'Vita Branches',
      branchesIn: 'Branches in',
      showing: 'Showing',
      of: 'of',
      branches: 'branches',
      mainBranch: 'MAIN BRANCH',
      contactInformation: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      timings: 'Timings',
      established: 'Established',
      manager: 'Manager',
      services: 'Services',
      facilities: 'Facilities',
      atms: 'ATMs',
      viewDetails: 'View Details',
      getDirections: 'Get Directions',
      call: 'Call',
      branchDetails: 'Branch Details',
      servicesOffered: 'Services Offered',
      facilitiesAvailable: 'Facilities Available',
      branchTimings: 'Branch Timings',
      mondayToFriday: 'Monday to Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed',
      language: 'Language',
      view: 'View',
      location: 'Location',
      quickActions: 'Quick Actions',
      visitNearest: 'Visit Your Nearest',
      shivpratapBank: 'Shivpratap Bank',
      branchToday: 'Branch Today',
      experienceBanking: 'Experience personalized banking services at our',
      convenientlyLocated: 'conveniently located branches across Maharashtra',
      contactSupport: 'Contact Support',
      customerSupport: 'Customer Support',
      branchNames: {
        'Main Branch, Vita': 'Main Branch, Vita',
        'Choundeshwari Temple Branch, Vita': 'Choundeshwari Temple Branch, Vita',
        'Sangli Branch': 'Sangli Branch',
        'Khanapur Branch': 'Khanapur Branch',
        'Tasgaon Branch': 'Tasgaon Branch',
        'Atpadi Branch': 'Atpadi Branch',
        'Mayani Branch': 'Mayani Branch',
        'Jat Branch': 'Jat Branch',
        'Kavathe Mahankal Branch': 'Kavathe Mahankal Branch',
        'Miraj Branch': 'Miraj Branch',
        'Karad Branch': 'Karad Branch',
        'Islampur Branch': 'Islampur Branch',
        'Ichalkaranji Branch': 'Ichalkaranji Branch',
        'Athani Branch': 'Athani Branch',
        'Bhalvani Branch': 'Bhalvani Branch',
        'Shirala Branch': 'Shirala Branch',
        'Peth Vadgaon Branch': 'Peth Vadgaon Branch',
        'Ashta Branch': 'Ashta Branch',
        'Akluj Branch': 'Akluj Branch',
        'Vashi Branch': 'Vashi Branch',
        'Koparkhairane Branch': 'Koparkhairane Branch',
        'Kalamboli Branch': 'Kalamboli Branch',
        'Vishrantwadi, Pune Branch': 'Vishrantwadi, Pune Branch',
        'Alsund Branch': 'Alsund Branch',
      },
      cityNames: {
        vita: 'Vita',
        sangli: 'Sangli',
        khanapur: 'Khanapur',
        tasgaon: 'Tasgaon',
        atpadi: 'Atpadi',
        mayani: 'Mayani',
        jat: 'Jat',
        kavathe_mahankal: 'Kavathe Mahankal',
        miraj: 'Miraj',
        karad: 'Karad',
        islampur: 'Islampur',
        ichalkaranji: 'Ichalkaranji',
        athani: 'Athani',
        bhalvani: 'Bhalvani',
        shirala: 'Shirala',
        peth_vadgaon: 'Peth Vadgaon',
        ashta: 'Ashta',
        alsund: 'Alsund',
        vashi: 'Vashi',
        koparkhairane: 'Koparkhairane',
        kalamboli: 'Kalamboli',
        pune: 'Pune'
      }
    },
    mr: {
      pageTitle: 'आमच्या शाखा',
      pageSubtitle: '',
      contactButton: 'संपर्क साधा',
      breadcrumbHome: 'होम',
      breadcrumbBranches: 'शाखा',
      headOffice: 'मुख्य कार्यालय',

      searchPlaceholder: 'नाव, शहर, पत्ता किंवा फोन नंबरने शाखा शोधा...',
      grid: 'ग्रिड',
      list: 'लिस्ट',
      allBranches: 'सर्व शाखा',
      headOfficeBtn: 'मुख्य कार्यालय',
      vitaBranches: 'विटा शाखा',

      branchesIn: 'मधील शाखा',
      showing: 'दाखवत आहे',
      of: 'पैकी',
      branches: 'शाखा',
      mainBranch: 'मुख्य शाखा',
      contactInformation: '',
      address: 'पत्ता',
      phone: 'फोन',
      email: 'ईमेल',
      timings: 'वेळ',
      established: 'स्थापना',
      manager: 'व्यवस्थापक',
      services: 'सेवा',
      facilities: 'सोयी',
      atms: 'एटीएम',
      viewDetails: 'तपशील पहा',
      getDirections: 'गूगल मॅप',
      call: 'कॉल करा',
      branchDetails: 'शाखा तपशील',
      servicesOffered: 'दिलेल्या सेवा',
      facilitiesAvailable: 'उपलब्ध सोयी',
      branchTimings: 'शाखा वेळ',
      mondayToFriday: 'सोमवार ते शुक्रवार',
      saturday: 'शनिवार',
      sunday: 'रविवार',
      closed: 'बंद',
      language: 'भाषा',
      view: 'दृश्य',
      location: 'स्थान',
      quickActions: 'त्वरित क्रिया',
      visitNearest: 'तुमच्या जवळची भेट द्या',
      shivpratapBank: 'शिवप्रताप बँक',
      branchToday: 'आज शाखा',
      experienceBanking: 'आमच्या वर वैयक्तिकृत बँकिंग सेवांचा अनुभव घ्या',
      convenientlyLocated: 'महाराष्ट्रमध्ये सोयीस्कर स्थानांवर आमाच्या',
      contactSupport: 'सपोर्टशी संपर्क साधा',
      customerSupport: 'ग्राहक सपोर्ट',
      branchNames: {
        'Main Office (Vita)': 'मुख्य कार्यालय (विटा)',
        'Main Branch, Vita': 'मुख्य शाखा, विटा',
        'Choundeshwari Temple Branch, Vita': 'चौंडेश्वरी मंदिर शाखा, विटा',
        'Sangli Branch': 'सांगली शाखा',
        'Khanapur Branch': 'खानापूर शाखा',
        'Tasgaon Branch': 'तासगाव शाखा',
        'Atpadi Branch': 'आटपाडी शाखा',
        'Mayani Branch': 'मायणी शाखा',
        'Jat Branch': 'जत शाखा',
        'Kavathe Mahankal Branch': 'कवठे महांकाळ शाखा',
        'Miraj Branch': 'मिरज शाखा',
        'Karad Branch': 'कराड शाखा',
        'Islampur Branch': 'ईश्वरपूर शाखा',
        'Ichalkaranji Branch': 'इचलकरंजी शाखा',
        'Athani Branch': 'अथणी शाखा',
        'Bhalvani Branch': 'भाळवणी शाखा',
        'Shirala Branch': 'शिराळा शाखा',
        'Peth Vadgaon Branch': 'पेठ वडगाव शाखा',
        'Ashta Branch': 'आष्टा शाखा',
        'Akluj Branch': 'अकलूज शाखा',
        'Vashi Branch': 'वाशी शाखा',
        'Koparkhairane Branch': 'कोपरखैरणे शाखा',
        'Kalamboli Branch': 'कळंबोली शाखा',
        'Vishrantwadi, Pune Branch': 'विश्रांतवाडी, पुणे शाखा',
        'Alsund Branch': 'आळसंद शाखा',
      },
      cityNames: {
        vita: 'विटा',
        sangli: 'सांगली',
        khanapur: 'खानापूर',
        tasgaon: 'तासगाव',
        atpadi: 'आटपाडी',
        mayani: 'मायणी',
        jat: 'जत',
        kavathe_mahankal: 'कवठे महांकाळ',
        miraj: 'मिरज',
        karad: 'कराड',
        islampur: 'इस्लामपूर',
        ichalkaranji: 'इचलकरंजी',
        athani: 'अठणी',
        bhalvani: 'भाळवणी',
        shirala: 'शिराळा',
        peth_vadgaon: 'पेठ वडगाव',
        ashta: 'आष्टा',
        alsund: 'आळसंद',
        vashi: 'वाशी',
        koparkhairane: 'कोपरखैरणे',
        kalamboli: 'कळंबोली',
        pune: 'पुणे'
      }
    }
  };

  // Get current language content
  const currentContent = translations[currentLang];

  // Helper function to get translated branch name
  const getTranslatedBranchName = (branch) => {
    if (branch.englishName && branch.marathiName) {
      return currentLang === 'en' ? branch.englishName : branch.marathiName;
    }
    const branchName = branch.name || '';
    return currentContent.branchNames[branchName] || branchName;
  };

  const [branches, setBranches] = useState([]);
  const [headOffice, setHeadOffice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const branchesRef = dbRef(database, 'shivpratapmultistate/branches');
        const snapshot = await get(branchesRef);
        if (snapshot.exists()) {
          const data = snapshot.val();
          const list = Object.keys(data).map(key => ({
            id: key,
            ...data[key]
          }));
          
          const dynamicHeadOffice = list.find(b => b.isHeadOffice);
          const otherBranches = list.filter(b => !b.isHeadOffice);
          
          if (dynamicHeadOffice) setHeadOffice(dynamicHeadOffice);
          setBranches(otherBranches);
        } else {
          setBranches([]);
          setHeadOffice(null);
        }
      } catch (error) {
        console.error('Error loading branches:', error);
      }
      setLoading(false);
    };
    loadData();
  }, []);

  const getCityName = (cityId) => currentContent.cityNames[cityId] || cityId;
  const uniqueCities = [...new Set(branches.map(b => b.city))];
  const cities = [
    { id: 'all', name: currentContent.allBranches, count: branches.length },
    ...uniqueCities.map(city => ({
      id: city,
      name: getCityName(city),
      count: branches.filter(b => b.city === city).length
    }))
  ];

  // Filter branches based on city and search
  const filteredBranches = branches.filter(branch => {
    const matchesCity = selectedCity === 'all' || branch.city === selectedCity;
    const branchName = branch.englishName || branch.name || '';
    const branchAddress = branch.englishAddress || branch.address || '';
    const branchPhone = branch.phone || '';
    const branchCity = branch.city || '';
    
    const matchesSearch = searchQuery === '' ||
      branchName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      branchAddress.toLowerCase().includes(searchQuery.toLowerCase()) ||
      branchCity.toLowerCase().includes(searchQuery.toLowerCase()) ||
      branchPhone.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCity && matchesSearch;
  });

  // Group branches by city for city-wise display
  const groupedBranches = filteredBranches.reduce((groups, branch) => {
    if (!groups[branch.city]) {
      groups[branch.city] = [];
    }
    groups[branch.city].push(branch);
    return groups;
  }, {});

  // (removed unused allServices array)

  // Handle branch selection
  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
    // Scroll to details section
    setTimeout(() => {
      const element = document.getElementById('branch-details');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Handle get directions
  const handleGetDirections = (branch) => {
    if (branch.mapLink) {
      window.open(branch.mapLink, '_blank');
      return;
    }
    const address = encodeURIComponent(currentLang === 'mr' && branch.addressMr ? branch.addressMr : branch.address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${address}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="font-sans bg-gradient-to-b from-rose-50 to-white">
      {/* 1. Hero Banner Section */}
      <section
        className="relative h-[300px] overflow-hidden"
        style={{
          background: 'linear-gradient(rgba(176, 52, 98, 0.85), rgba(176, 52, 98, 0.8))',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0">
          {/* Pattern Overlay */}
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`,
            backgroundSize: '300px'
          }}></div>
        </div>

        <div className="relative h-full flex flex-col justify-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Breadcrumb */}
            <nav className="flex items-center text-blue-100 text-sm mb-6">
              <a href="/" className="flex items-center hover:text-white transition-colors">
                <FaHome className="mr-2" />
                {currentContent.breadcrumbHome}
              </a>
              <FaChevronRight className="mx-2 opacity-50" />
              <span className="font-semibold text-white">{currentContent.breadcrumbBranches}</span>
            </nav>

            {/* Page Heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              {currentContent.pageTitle.split(' ')[0]} <span className="bg-gradient-to-r from-rose-300 to-pink-300 bg-clip-text text-transparent">{currentContent.pageTitle.split(' ')[1]}</span>
            </h1>

          </div>
        </div>
      </section >



      {/* Main Content */}
      < div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" >
        <div className="grid grid-cols-1 gap-8">
          {/* Left Column - Branches List */}
          <div className="lg:col-span-2 space-y-12">
            {/* 3. Head Office Section */}
            {headOffice && (
              <section id="head-office" className="scroll-mt-24">
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
                  <div className="relative h-48 bg-gradient-to-r from-rose-600 to-rose-800">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute inset-0 flex items-center justify-center p-6 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-white drop-shadow-lg">
                      {getTranslatedBranchName(headOffice)}
                    </h2>
                  </div>
                </div>
                <div className="p-8 relative overflow-hidden">
                  {/* Main Branch Watermark */}
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5">
                    <div className="text-6xl font-bold text-gray-300 transform rotate-45 scale-150">MAIN BRANCH</div>
                  </div>

                  <div className="relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      {/* Contact Information Only */}
                      <div className="md:col-span-2">
                        <h3 className="text-xl font-bold text-gray-800 mb-6">{currentContent.contactInformation}</h3>
                        <div className="space-y-4">
                          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                            <div className="flex items-start">
                              <FaMapMarkerAlt className="text-rose-600 mt-1 mr-3 flex-shrink-0" />
                              <div>
                                <div className="font-medium text-gray-800">{currentContent.address}</div>
                                <div className="text-gray-600">
                                  {currentLang === 'en' ? (headOffice.englishAddress || headOffice.address || headOffice.addressMr) : (headOffice.marathiAddress || headOffice.addressMr || headOffice.address)}
                                </div>
                              </div>
                            </div>
                            <div className="flex-shrink-0">
                              <button
                                onClick={() => handleGetDirections(headOffice)}
                                className="flex items-center justify-center px-6 py-2.5 rounded-lg border-2 border-rose-600 text-rose-600 font-semibold hover:bg-rose-50 transition-all duration-300"
                              >
                                <FaDirections className="mr-2" />
                                {currentContent.getDirections}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

            {/* 4. City-wise Branch Listing */}
            <section id="branch-listing" className="scroll-mt-24">
              <div className="flex items-center justify-between mb-8">
                <div className="text-gray-600">
                  {selectedCity === 'all' ? '' : `${currentContent.branchesIn} ${cities.find(c => c.id === selectedCity)?.name}`}
                </div>
                <div className="text-gray-600">
                  {currentContent.showing} {filteredBranches.length} {currentContent.of} {branches.length} {currentContent.branches}
                </div>
              </div>



              {/* Branch Cards - All Mixed Together */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredBranches.map(branch => (
                  <div
                    key={branch.id}
                    className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:border-rose-400 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
                  >
                    {/* Branch Header */}
                    <div className="bg-gradient-to-r from-rose-600 to-rose-700 p-4">
                      <h4 className="text-lg font-bold text-white mb-1">{getTranslatedBranchName(branch)}</h4>

                    </div>

                    {/* Branch Details */}
                    <div className="p-5">
                      <div className="mb-5">
                        <div className="flex items-start">
                          <FaMapMarkerAlt className="text-rose-500 mt-1 mr-2.5 flex-shrink-0 text-sm" />
                          <div className="text-gray-600 text-sm leading-relaxed">
                            {currentLang === 'en' ? (branch.englishAddress || branch.address || branch.addressMr) : (branch.marathiAddress || branch.addressMr || branch.address)}
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="space-y-2.5">

                        <button
                          onClick={() => handleGetDirections(branch)}
                          className="w-full flex items-center justify-center px-4 py-2.5 rounded-lg border-2 border-rose-600 text-rose-600 font-semibold hover:bg-rose-50 transition-all duration-300"
                        >
                          <FaDirections className="mr-2" />
                          {currentContent.getDirections}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>


        </div>

        {/* 5. Branch Details Section */}
        {selectedBranch && (
          <section id="branch-details" className="scroll-mt-24 mt-12">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
              <div className="relative h-48 bg-gradient-to-r from-rose-600 to-rose-800">
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-4xl font-bold text-white">{getTranslatedBranchName(selectedBranch)}</h2>
                      <p className="text-rose-100 text-lg">
                        {cities.find(c => c.id === selectedBranch.city)?.name || selectedBranch.city}
                      </p>
                    </div>
                    <button
                      onClick={() => setSelectedBranch(null)}
                      className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-100 transition-colors"
                    >
                      <FaTimes size={20} />
                    </button>
                  </div>
                </div>
              </div>

              <div className="p-8">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Contact Details & Map */}
                  <div className="lg:col-span-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-6">{currentContent.branchDetails}</h3>
                        <div className="space-y-4">
                          <div className="flex items-start">
                            <FaMapMarkerAlt className="text-rose-600 mt-1 mr-4 flex-shrink-0" />
                            <div>
                              <div className="font-bold text-gray-800">{currentContent.address}</div>
                              <div className="text-gray-700">
                                {currentLang === 'en' ? (selectedBranch.englishAddress || selectedBranch.address || selectedBranch.addressMr) : (selectedBranch.marathiAddress || selectedBranch.addressMr || selectedBranch.address)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Map */}
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-4">{currentContent.location}</h3>
                        <div className="bg-gray-100 rounded-xl h-64 overflow-hidden">
                          <iframe
                            src={`https://maps.google.com/maps?q=${encodeURIComponent(currentLang === 'mr' ? (selectedBranch.marathiAddress || selectedBranch.addressMr) : (selectedBranch.englishAddress || selectedBranch.address))}&output=embed`}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Branch Location Map"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">{currentContent.quickActions}</h3>
                    <button
                      onClick={() => handleGetDirections(selectedBranch)}
                      className="w-full bg-gradient-to-r from-rose-600 to-rose-800 text-white py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
                    >
                      <FaDirections className="mr-3" />
                      {currentContent.getDirections}
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </section>
        )}



      </div >
    </div >
  );
};

export default Branch;